import React from 'react'

function AttendedEventsPage() {
  return (
    <div>AttendedEventsPage</div>
  )
}

export default AttendedEventsPage